import { roles } from '@nxsys/store/constants';
import RTWReport from '../../../modules/reports/employee/listing/RTWReport';
import AWRReport from '../../../modules/reports/employee/listing/AWRReport/AWRReport';
import WTRReport from '../../../modules/reports/employee/listing/WTRReport';

export const employeeReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/employee/right-to-work',
    element: <RTWReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/employee/awr',
    element: <AWRReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/employee/wtr',
    element: <WTRReport />,
  },
];
